<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Antrag-Daten</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Tragen Sie hier die Straße des zu versichernden Gebäudes ein.
                    </Rechner-hint-col>
                    <v-flex xs7>
                        <Rechner-field-col :fielddef="fieldDefs.glas_lage_strasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs3>
                        <Rechner-field-col :fielddef="fieldDefs.glas_lage_strasse_nr" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Tragen Sie hier die Postleitzahl und den Ort des zu versichernden Gebäudes ein.
                        <br>
                        <br>Diese Daten werden benötigt, da jeder Postleitzahl eine sogenannte Tarifzone zugeordnet ist.
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.glas_lage_plz" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.glas_lage_ort" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Wählen Sie hier die <b>Gebäudeart</b> Ihres Wohnhauses aus:
                        <div style="border-top:1px solid #ccc">
                            <b><i>Wohnung</i></b>:
                            Text Text Text
                        </div>
                        <div style="border-top:1px solid #ccc">
                            <b><i>Einfamilienhaus</i></b>:
                            freistehendes Gebäude mit einzelnem Grundstück, ohne ein an die Hauswand angrenzendes Nachbargebäude.
                            <br>
                            <br>
                        </div>


                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.glas_typ_art"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!--============================================================================================================-->
                <!--
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Fragen zum Vertrag</h6></v-flex>
                </v-layout>
                -->
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Sie können den Versicherungsbeginn bestimmen!
                        <br>Der Beginn ist frühestens am nächsten Tag möglich.
                        <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  import slideMixin from '../stepMixin'
  import _ from 'lodash'
  //import {mapState} from 'vuex'

  export default {
    //========================================================================================================
    name: 'Step_glasbruch_I',
    label: 'Haus/Wohnung Daten',
    label2: 'Daten zum<br>Haus/Wohnung',
    fieldKeys: [
      'glas_lage_strasse_nr',
      'glas_lage_strasse',
      'glas_lage_plz',
      'glas_lage_ort',
      'glas_typ_art',

      'vertrag_zahlungsweise',
      'vertrag_beginn',
    ],
    //========================================================================================================
    data: function () {
      //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
      //an dieser Stelle können diese Werte überschrieben werden.
      // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
      var fieldDefs_OVERRIDE = {}

      return {
        fieldDefs: fieldDefs_OVERRIDE,

      }
    }, //========================================================================================================
    mixins: [slideMixin],
    //===========================================================================================================
    watch: {

      value: {
        handler: function (newVal, oldVal) {
          console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
          console.log("WATCHER fieldValues in ", this.$options.label)
          // var fD = this.fieldDefs
          var fV = this.value.fieldValues
          var fVold = this.frmValuesOld

          var earlyExit = true;
          for (var key in fV) {
            if (fV[key] !== fVold[key]) {
              earlyExit = false
              console.log("changed ", key, fVold[key], '->', fV[key])
              this.update_Ort_by_PLZ(key)
            }
          }
          if (earlyExit === true) {
            console.log("NO changes -> early EXIT")
            return;
          }
          //----------------------------------------------------------------------------
          // -> hier evtl. reaktion auf Änderungen von Form-Values

          //----------------------------------------------------------------------------

          this.frmValuesOld = _.assign({}, fV)

        },
        deep: true,

      },
    }, //========================================================================================================
    components: {/* programmatically setted by step-mixin*/},
    //===========================================================================================================
    props: [/* programmatically setted by step-mixin*/],
    //===========================================================================================================
    // HOOKS:
    /* programmatically setted by step-mixin*/
    //===========================================================================================================
  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
